import type { IApiConfig } from "@hopper-b2b/types";
import { postFetchFeatureFlags } from "../api";
import type { FeatureFlagsContext } from "../FeatureFlagsProvider";

export const initFeatureFlagsState = async (
  shouldFetchExperiments = false,
  apiConfig: IApiConfig,
  defaultInitState: FeatureFlagsContext
): Promise<FeatureFlagsContext> => {
  const fetchExperiments: () => Promise<FeatureFlagsContext> =
    shouldFetchExperiments
      ? () => postFetchFeatureFlags(apiConfig)
      : () => Promise.resolve(defaultInitState);

  return fetchExperiments();
};
